import { render, staticRenderFns } from "./QuotationApprove.vue?vue&type=template&id=7efcf84d&scoped=true"
import script from "./QuotationApprove.vue?vue&type=script&lang=js"
export * from "./QuotationApprove.vue?vue&type=script&lang=js"
import style0 from "./QuotationApprove.vue?vue&type=style&index=0&id=7efcf84d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7efcf84d",
  null
  
)

export default component.exports